import React from 'react';
import { ArrowRightIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link as ReactLink } from 'react-router-dom';
import Link from './Link';
import clsx from 'clsx';

function Banner({ children, onClose, href }) {
  const Component = href ? ReactLink : 'div';

  return (
    <Component
      className={clsx('bg-purple-900 relative block top-0 left-0 w-full z-50 transition-colors', {
        'cursor-pointer hover:bg-purple-800': href,
      })}
      to={href}
    >
      <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
        <div className={clsx('sm:px-16 sm:text-center', { 'pr-16': onClose })}>
          <div className="text-white space-x-2 flex justify-center items-center">{children}</div>
        </div>

        {onClose && (
          <div className="absolute inset-y-0 right-0 flex items-start pt-1 pr-1 sm:items-start sm:pt-1 sm:pr-2">
            <button
              type="button"
              className="flex rounded-md p-2 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-white"
              onClick={onClose}
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>
        )}
      </div>
    </Component>
  );
}

const BannerMessage = ({ children }) => {
  return <span>{children}</span>;
};

const BannerAction = ({ children }) => {
  return <span className="">{children}</span>;
};

const BannerActionLink = ({ children, href }) => {
  return (
    <Link
      to={href}
      className="group text-white hover:text-gray-200 transition-colors inline-block"
      variant="withIcon"
    >
      {children}

      <ArrowRightIcon
        className="h-4 w-4 text-white group-hover:text-gray-200 transition-colors"
        aria-hidden="true"
      />
    </Link>
  );
};

const BannerDivider = ({ children }) => {
  return <span>{children}</span>;
};

Banner.Message = BannerMessage;
Banner.Divider = BannerDivider;
Banner.Action = BannerAction;
Banner.ActionLink = BannerActionLink;

export default Banner;
